module.exports = __webpack_public_path__ + "img/annotation3.b4de3a25.svg";